import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import {
  ELITE_PLANS_DEFAULT_TIER,
  ELITE_PLANS_TIER_QUERY_PARAM
} from '../constants/planIds'

export function parseTierParam(value: string | null, planOrder: string[]): string {
  if (value && planOrder.includes(value)) return value
  return planOrder[0] ?? ELITE_PLANS_DEFAULT_TIER
}

export function useElitePlansTier(planOrder: string[]) {
  const [searchParams, setSearchParams] = useSearchParams()
  const selectedPlanId = parseTierParam(
    searchParams.get(ELITE_PLANS_TIER_QUERY_PARAM),
    planOrder
  )

  const setSelectedPlanId = useCallback(
    (planId: string) => {
      if (!planOrder.includes(planId)) return
      const next = new URLSearchParams(searchParams)
      next.set(ELITE_PLANS_TIER_QUERY_PARAM, planId)
      setSearchParams(next, { replace: true })
    },
    [planOrder, searchParams, setSearchParams]
  )

  return { selectedPlanId, setSelectedPlanId }
}
